import { ButtonGroup, Tooltip } from "@mui/material"
import { useTranslation } from "react-i18next"

import type { PlotTabsConfig } from "types/dashboard.types"
import type { PlotTabVisibility } from "helpers/hooks/plots/usePlotTabVisibility"
import { ALL_TAB } from "helpers/hooks/plots/usePlotTabVisibility"
import { TabButton } from "widgets/styled/buttons"

interface PlotTabLegendProps {
  tabsConfig: PlotTabsConfig
  visibility: PlotTabVisibility
}

const PlotTabLegend = ({ tabsConfig, visibility }: PlotTabLegendProps) => {
  const { t } = useTranslation()
  const { tabs, showAllTab } = tabsConfig
  const { activeTab, setActiveTab } = visibility

  if (tabs.length <= 1 && !showAllTab) return null

  return (
    <ButtonGroup
      variant="outlined"
      size="small"
      sx={{ display: "flex", justifyContent: "flex-start", px: 0.5, pb: 0.5 }}
    >
      {tabs.map((tab) => {
        const btn = (
          <TabButton
            key={tab.id}
            variant={activeTab === tab.id ? "contained" : "outlined"}
            onClick={() => setActiveTab(tab.id)}
            sx={{ px: 1, py: 0.4, fontSize: "0.7rem" }}
          >
            {t(tab.labelKey)}
          </TabButton>
        )
        return tab.tooltipKey ? (
          <Tooltip key={tab.id} title={t(tab.tooltipKey)} arrow placement="bottom-start">
            <span>{btn}</span>
          </Tooltip>
        ) : (
          btn
        )
      })}
      {showAllTab && (
        <TabButton
          variant={activeTab === ALL_TAB ? "contained" : "outlined"}
          onClick={() => setActiveTab(ALL_TAB)}
          sx={{ px: 1, py: 0.25, fontSize: "0.7rem" }}
        >
          {t("plot_legends.ALL")}
        </TabButton>
      )}
    </ButtonGroup>
  )
}

export default PlotTabLegend
